import { useEffect, useState } from 'react';

/**
 * Підписка на CSS media query з JS.
 *
 * Потрібна там, де від ширини екрана залежить не лише оформлення, а й
 * поведінка: на телефоні деталі замовлення відкриваються панеллю, а на
 * десктопі — просто заповнюють другу колонку.
 */
const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(
        () => typeof window !== 'undefined' && window.matchMedia(query).matches
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia(query);
        const handler = (event) => setMatches(event.matches);

        setMatches(mediaQuery.matches);
        mediaQuery.addEventListener('change', handler);

        return () => mediaQuery.removeEventListener('change', handler);
    }, [query]);

    return matches;
};

/** Порогове значення збігається з макетом .rc-split у app.css */
export const useIsDesktop = () => useMediaQuery('(min-width: 1024px)');

export default useMediaQuery;
